export default __webpack_public_path__ + "static/media/display-with-keypad.2b5d8c9b.png";